import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export type ConfirmCopy = { title: string; body: string };

/** Slice 3-3's wording for publishing a tactic. */
export function publishConfirmCopy(tactic: string, keyword: string, market: string): ConfirmCopy {
  return {
    title: `Publish ${tactic} on "${keyword}" (${market}) to Amazon?`,
    body: "This creates a LIVE negative keyword: ads stop serving on this query. Nothing has reached Amazon until you confirm.",
  };
}

/** Slice 3-3's wording for undoing a tactic. Retire changes nothing on Amazon, and says so. */
export function undoConfirmCopy(
  kind: "reverse" | "retire",
  tactic: string,
  keyword: string,
  market: string,
): ConfirmCopy {
  return kind === "retire"
    ? {
        title: `Retire the ledger entry for ${tactic} on "${keyword}" (${market})?`,
        body: "This application was never published, so nothing changes on Amazon: it only marks the ledger row retired.",
      }
    : {
        title: `Reverse ${tactic} on "${keyword}" (${market})?`,
        body: "This archives the negative keyword on Amazon and marks the application Reversed. Ads can serve on this query again.",
      };
}

/** The app's confirmation for an action that reaches Amazon or the ledger. */
export function ConfirmActionDialog({
  open,
  onOpenChange,
  copy,
  confirmLabel,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  copy: ConfirmCopy;
  confirmLabel: string;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.body}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!open) return;
              onOpenChange(false);
              onConfirm();
            }}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
